import DosApprovalList from './component';
import _routes from './routes';

export const routes = _routes;
export default DosApprovalList;



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/DosApprovalList/index.js